import React, { useEffect } from "react";
import SideMenu from "../../Components/SideMenu";
import { useDispatch, useSelector } from "react-redux";
import { getWhatsappTemplate } from "../../reducers/commonReducer";
import { Button } from "react-bootstrap";
import { shortTextMsg } from "../../const";

function TemplateList() {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getWhatsappTemplate());
  }, []);
  const { whatsappTemplateList } = useSelector((state) => state.commonReducer);

  return (
    <>
      <SideMenu />
      <div className="mt-extra content container-fluid">
        <table className="table table-scrolling ">
          <thead className="normalplace">
            <tr>
              <th className="over-col-size">Sr</th>
              <th className="over-col-size">Name</th>
              <th className="over-col-size">Category</th>
              <th className="over-col-size">Message Temp</th>
              <th className="over-col-size">Status</th>
            </tr>
          </thead>
          <tbody>
            {!!whatsappTemplateList &&
              whatsappTemplateList?.map((data, index) => {
                return (
                  <React.Fragment key={index}>
                    <tr key={data?._id}>
                      <td>{index + 1}.</td>
                      <td>{data?.name}</td>
                      <td>{data?.category}</td>
                      <td>
                        {data?.components?.map((msg, msgIndx) => {
                          return (
                            <React.Fragment key={msgIndx}>
                              {msg?.format === "IMAGE" &&
                                msg?.example?.header_handle?.map((img) => (
                                  <img className="w-100" src={img} />
                                ))}
                              <p
                                dangerouslySetInnerHTML={{
                                  __html: shortTextMsg(msg?.text || ""),
                                }}
                              />
                              {msg?.type === "BUTTONS" &&
                                msg?.buttons?.map((btn, index) => {
                                  if (btn?.type === "URL") {
                                    return (
                                      <a
                                        key={index}
                                        href={btn?.url}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="btn btn-primary m-1"
                                      >
                                        {btn?.text}
                                      </a>
                                    );
                                  } else if (btn?.type === "PHONE_NUMBER") {
                                    return (
                                      <a
                                        key={index}
                                        href={`tel:${
                                          btn?.phone_number || btn?.url
                                        }`}
                                        className="btn btn-success m-1"
                                      >
                                        {btn?.text}
                                      </a>
                                    );
                                  } else {
                                    return (
                                      <Button
                                        key={index}
                                        onClick={() =>
                                          window.location.assign(btn?.url)
                                        }
                                        className="m-1"
                                      >
                                        {btn?.text}
                                      </Button>
                                    );
                                  }
                                })}
                            </React.Fragment>
                          );
                        })}
                      </td>
                      <td>
                        <b>{data?.status}</b>
                      </td>
                    </tr>
                  </React.Fragment>
                );
              })}
          </tbody>
        </table>
      </div>
    </>
  );
}

export default TemplateList;
